

module.exports = __webpack_require__.stylable.create(
    "Footer3464137044",
    {"classes":{"root":"Footer3464137044__root","benefits":"Footer3464137044__benefits","arrow":"Footer3464137044__arrow"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Footer3464137044",
    null
);
